import { Duration } from "date-fns";

export const numberToDateTimeString = (timeDiff: number): Duration => {
  const hour = 60;
  const day = hour * 24;
  const newTimeDiff = Math.abs(timeDiff);
  const diffDays = Math.floor(newTimeDiff / day);
  const diffHours = Math.round(Math.floor((newTimeDiff % day) / hour));
  const diffMinutes = Math.round(Math.floor(newTimeDiff % hour));

  return {
    days: diffDays,
    hours: diffHours,
    minutes: diffMinutes,
  };
};
